import React from 'react';
import { HardHat } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div className="flex items-center gap-2 mb-4 md:mb-0">
                        <HardHat className="text-gold-500 w-8 h-8" />
                        <span className="text-white font-bold text-xl">NOPA ENGINEERING</span>
                    </div>

                    <div className="flex gap-8 text-sm">
                        <a href="#about" className="hover:text-gold-500 transition-colors">About</a>
                        <a href="#services" className="hover:text-gold-500 transition-colors">Services</a>
                        <a href="#projects" className="hover:text-gold-500 transition-colors">Projects</a>
                        <a href="#contact" className="hover:text-gold-500 transition-colors">Contact</a>
                    </div>
                </div>

                <div className="border-t border-slate-800 mt-8 pt-8 text-center text-sm">
                    <p>&copy; {new Date().getFullYear()} NOPA ENGINEERING. All rights reserved.</p>
                    <p className="mt-2 text-slate-500">PIB: 115056646 | MB: 68058970</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
